import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
//
//component
import AppAuth from "./app_auth";
import {
  snapBailiffAuth,
  unSnapBailiffAuth,
} from "store/bailiff/auth/bailiff_auth.action";
import { snapUserAuth, unSnapUserAuth } from "store/user/auth/user_auth.action";
import { getOnboardFirst } from "store/bailiff/onboard/onboard.action";
//redux
//selector
//actions

//utils
//hook
//str
const AppRoot = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    dispatch(snapUserAuth());
    return () => {
      dispatch(unSnapUserAuth());
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(snapBailiffAuth());
    return () => {
      dispatch(unSnapBailiffAuth());
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(getOnboardFirst());
  }, [dispatch]);
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return <AppAuth />;
};
export default AppRoot;
